var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-checkbox',{staticClass:"checkbox",attrs:{"checked":_vm.value,"indeterminate":_vm.indeterminate,"disabled":_vm.disabled},on:{"change":_vm.selected}})
}
var staticRenderFns = []

export { render, staticRenderFns }